import React, { useEffect, useRef, useState } from 'react'
import './StoreProductsGroup.css'
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaCircleCheck } from "react-icons/fa6";
import { useTelegram } from '../../../../hooks/auth/useTelegram';
import { useGet } from '../../../../hooks/useGet';
import { toast } from 'react-toastify';
import Modal from '../../../../Components/Modal/Modal';
import { MdOutlineSearch } from "react-icons/md";
import config from '../../../../config';
import axios from 'axios';
import api from '../../../../hooks/api';

function StoreProductsGroup({ fn_close, group_id }) {

    const [isTitleEdit, setIsTitleEdit] = useState(false);
    const [title, setTitle] = useState(null);
    const [image_path, setImagePath] = useState(null)
    const [fileImagePath, setFileImagePath] = useState(null)
    const [is_image_deleted, setIsImageDeleted] = useState(false)
    const [is_image_updated, setIsImageUpdated] = useState(false)

    const [isVisible, setIsVisible] = useState(true);
    const { data, isLoading, error } = useGet(group_id ? `commodity/group/show/${group_id}` : null);

    useEffect(() => {
        if (data) {
            setTitle(data.title)
            data.image_path && setImagePath(`${config.api.imageURL}/${data.image_path}`)
        }
    }, [data])
    const eventToggle = () => {
        fn_close()
        setIsVisible(false)
    }
    const edit_group = () => {

        const form = {
            id_commodityGroup: group_id,
            title: title,
            is_image_updated: is_image_updated,
            is_image_deleted: is_image_deleted,
            description: null,
            image_path: fileImagePath,
            commodityList: []
        }

        api.post(`commodity/group/update`, form, { headers: { "Content-Type": "multipart/form-data" } })
            .then((response) => {
                if (response.data.success) {
                    toast.success(response.data.message, {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        rtl: "true"
                    });
                } else {
                    toast.error(response.data.message, {
                        position: "top-left",
                        autoClose: 1000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        rtl: "true"
                    });
                }
            });
    }
    return (
        <Modal eventToggle={eventToggle} isOpen={isVisible} locked={true} fullscreen={true}>
            <div className='product-group'>

                <div className="topbar-group" >
                    <div className="right"></div>
                    <div className="formTitle">
                        <span>دسته بندی</span>
                    </div>

                    <div className="back" onClick={eventToggle}>
                        <div className="btn-back"><IoMdArrowRoundBack size={"25px"} /></div>
                        <div className='back-title'>بازگشت</div>
                    </div>
                </div>

                <div className="context">
                    <div className="wrapper-context">
                        <div className="header-wrraper">
                            <div className="header-body">
                                <div className="image-edit">
                                    <div className="btn-edit" onClick={(e) => {

                                        e.stopPropagation();
                                        document.querySelector(".img-logo").click()
                                    }
                                    }>
                                        <img src={process.env.PUBLIC_URL + '/images/controls/edit.png'} />
                                        <input type='file' accept='image/*' className="img-logo" style={{ display: "none" }}
                                            onChange={({ target: { files } }) => {

                                                files[0] && setFileImagePath(files[0])
                                                files[0] && setIsImageUpdated(true)


                                                if (files)
                                                    setImagePath(URL.createObjectURL(files[0]))
                                            }}
                                        />
                                    </div>
                                    {image_path && <img src={image_path} />}
                                    {!image_path && <span>1x1</span>}

                                </div>
                                <div className="title-edit">
                                    <input type='text' defaultValue={title} disabled={isTitleEdit} onChange={(e) => setTitle(e.target.value)} />
                                    <div className="btn-edit" onClick={
                                        (e) => {
                                            e.stopPropagation();
                                            setIsTitleEdit(!isTitleEdit)
                                        }} >
                                        <img src={process.env.PUBLIC_URL + '/images/controls/edit.png'} />
                                    </div>
                                </div>
                                <div className="search-wrraper">
                                    <div className="search-context">
                                        <div className="img-search">
                                            <MdOutlineSearch size={"30px"} />
                                        </div>
                                        <div className="text-search">
                                            <input type='text' />
                                        </div>
                                    </div>
                                    <div className="btn-add-group">
                                        افزودن
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="commodity-wrraper">
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                            <div className="commodity-body">
                                <div className="image">
                                    <span>عکس محصول</span>
                                </div>
                                <div className="context">
                                    <span>عنوان محصول</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="save-wrraper">
                    <div className="btn-group-save" onClick={() => {
                        edit_group()
                    }}>
                        ثبت
                    </div>
                </div>

            </div>
        </Modal>
    )
}

export default StoreProductsGroup